import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const VolitelnyMaterialSp = {
	name: NAME,
	apiProvider,
	router,
};
